// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__+ZisF","namePhoneContainer":"style_namePhoneContainer__tNQ-s"};